import React, { useEffect, useState } from "react";
import { Input, Button, Table, Popconfirm, message } from "antd";
import axios from "axios";

export default function Locality() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
console.log("list",list)
  const [formData, setFormData] = useState({
    id: null,
    locality: "",
    slug: "",
  });

  /* 🔁 Auto-generate slug */
  useEffect(() => {
    if (formData.locality) {
      const slug = formData.locality
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/--+/g, "-")
        .trim();

      setFormData((prev) => ({ ...prev, slug }));
    }
  }, [formData.locality]);

  /* 📥 Fetch Localities */
  const fetchLocalities = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        "https://skdm.in/server/sdg/property.php?action=fetchLocation"
      );
      console.log("object",res)
      setList(res?.data?.list || []);
      console.log("objresect",res)
    } catch {
      message.error("Failed to fetch localities");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLocalities();
  }, []);

  /* ➕ Add / ✏️ Update */
  const handleSubmit = async () => {
    if (!formData.locality) {
      message.warning("Locality name is required");
      return;
    }

    try {
      setLoading(true);

      const payload = new FormData();
      payload.append(
        "action",
        formData.id ? "update_locality" : "add_locality"
      );
      payload.append("locality", formData.locality);
      payload.append("slug", formData.slug);

      if (formData.id) {
        payload.append("id", formData.id);
      }

      await axios.post(
        "https://skdm.in/server/sdg/locality.php",
        payload
      );

      message.success(
        formData.id ? "Locality updated" : "Locality added"
      );

      setFormData({ id: null, locality: "", slug: "" });
      fetchLocalities();
    } catch {
      message.error("Operation failed");
    } finally {
      setLoading(false);
    }
  };

  /* 🗑 Delete */
  const handleDelete = async (id) => {
    try {
      await axios.post("https://skdm.in/server/sdg/locality.php", {
        action: "delete_locality",
        id,
      });
      message.success("Locality deleted");
      fetchLocalities();
    } catch {
      message.error("Delete failed");
    }
  };

  /* ✏️ Edit */
  const handleEdit = (record) => {
    setFormData({
      id: record.id,
      locality: record.locality,
      slug: record.slug,
    });
  };

  const columns = [
    { title: "Locality", dataIndex: "property_locality" },
    { title: "Slug", dataIndex: "slug" },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Button
            size="small"
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>

          <Popconfirm
            title="Delete this locality?"
            onConfirm={() => handleDelete(record.id)}
          >
            <Button
              size="small"
              danger
              className="ms-2"
            >
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h3 className="mb-3">
        {formData.id ? "Update Locality" : "Add Locality"}
      </h3>

      <Input
        placeholder="Enter locality name"
        value={formData.locality}
        onChange={(e) =>
          setFormData((prev) => ({
            ...prev,
            locality: e.target.value,
          }))
        }
      />

      <Input
        className="mt-2"
        value={formData.slug}
        disabled
        placeholder="Auto-generated slug"
      />

      <Button
        type="primary"
        className="mt-3"
        loading={loading}
        onClick={handleSubmit}
      >
        {formData.id ? "Update" : "Add"}
      </Button>

      <Table
        className="mt-4"
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}
